<template>
  <v-app>
    <router-view v-if="isSigned && !loading"/>
    <ObnovaHesla v-if="!isSigned && !loading && recover_password" @signed="check()" :verifing_token="verifing_token" :verifing_token_error="verifing_token_error"></ObnovaHesla>
    <Login v-if="!isSigned && !loading && !recover_password" @signed="check()"></Login>
    <v-footer v-if="isSigned && !loading">
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <img src="@/assets/images/logo-cc-tu.png" alt="Logo" width="95px">
          <h3 class="mb-3"><span class="text-uppercase">Comfort Commodity</span> a.s.</h3>
          <h4 class="mb-0">
            <a class="link-black footer-link" href="tel:+420734232022">+420 734 232 022</a>
            <a class="link-black footer-link" href="mailto:info@comfort-commodity.cz">info@comfort-commodity.cz</a>
            <!-- <a class="link-black" href="https://goo.gl/maps/RpKsoS2o429iNJoz9" target="_blank">Plaská 2119/54a, CZ 323 00 Plzeň</a> -->
          </h4>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>

import Login from '@/components/Login'
import ObnovaHesla from '@/components/ObnovaHesla'

export default {
  name: 'App',
  data () {
    return {
      bottomNav: 'eshop',
      mobileMenu: false,
      isSigned: false,
      loading: false,
      kosik: null,
      alert: false,
      recover_password: false,
      verifing_token: false,
      verifing_token_error: false
    };
  },
  computed: {
    me: function() {
      return window.$me;
    },
    api_url () {
      return window.api.$api_url;
    }
  },
  watch:{
    $route (to, from){
      if (this.$router.history.current.path == "/obnova-hesla") {
        this.recover_password = true;
      }
      else {
        if (this.recover_password) {
          this.recover_password = false;
          this.$nextTick(function () {
            this.check();
          }.bind(this));
          window.Kosik.listen(() => {
            this.loadKosik();
          });
        }
      }
    }
  },
  mounted () {
    if (this.$router.history.current.path == "/obnova-hesla") {
      this.recover_password = true;
    }
    else if (this.$router.history.current.path.startsWith("/obnova-hesla/")) {
      var token = this.$router.history.current.path.substr("/obnova-hesla/".length);
      this.recover_password = true;
      this.verifing_token = true;
      this.verifing_token_error = false;
      window.API.post("session/obnovit-heslo-token", {
          token: token
      }).then(function(body) {
        if (body.prihlasen) {
          //window.API.$setCookie("hn_org", body.UID.toString(), { expires: 30, path: "/" });
          window.API.$setCookie("cc_eshop_uid", body.uid.toString(), { expires: 30, path: "/" });
          window.API.$setCookie("cc_eshop_token", body.token, { expires: 30, path: "/" });
          //this.verifing_token = false;
          this.$router.push({ path: "/" });
          this.check();
        }
        else {
          this.verifing_token_error = true;
          this.verifing_token = false;
        }
      }.bind(this)).catch(function(err) {
        this.verifing_token = false;
        this.verifing_token_error = true;
      }.bind(this));
    }
    else {
      this.$nextTick(function () {
        this.check();
      }.bind(this));
      window.Kosik.listen(() => {
        this.loadKosik();
      });
    }
  },
  methods: {
    check: function() {
      this.loading = true;
      var x = 0; var y = 0;
      try {
        var win = window,
          doc = document,
          docElem = doc.documentElement,
          body = doc.getElementsByTagName('body')[0];
        x = win.innerWidth || docElem.clientWidth || body.clientWidth;
        y = win.innerHeight|| docElem.clientHeight|| body.clientHeight;
      }
      catch ($e) {

      }
      window.API.post("uzivatel", {
        prohlizec: window.MobileDetect.userAgent(),
        zarizeni: window.MobileDetect.tablet() ? 'tablet' : (window.MobileDetect.mobile() ? 'mobil' : 'pc'),
        os: window.MobileDetect.os(),
        rozliseni_sirka: x,
        rozliseni_vyska: y
      }).then(function(body) {
        window.$me = body;
        window.$user = body;
        this.$data.isSigned = typeof body.prihlasen !== "undefined" && body.prihlasen;
        this.loadKosik(() => {
          this.loading = false;
        });
      }.bind(this)).catch(function(err) {
          this.$data.isSigned = false;
          this.loading = false;
          console.log(err);
      }.bind(this));
    },
    loadKosik (f) {
      window.API.get("kosik").then(function(body) {
        this.kosik = body;
        if (typeof f == "function")
          f();
      }.bind(this)).catch(function(err) {
        if (typeof f == "function")
          f();
      }.bind(this));
    },
    signout: function() {
      window.API.$setCookie("cc_eshop_uid", "", { expires: -30, path: "/" });
      window.API.$setCookie("cc_eshop_token", "", { expires: -30, path: "/" });
      window.location.reload();
    }
  },
  components: {
    Login, ObnovaHesla
  }
}
</script>
